import { InvoiceDisplayStatusV2, PaymentDetailType } from 'anchor-scout-common/types';
import { Accounting } from '~/types/api.model';
export function isRefundRequested(invoice) {
    return invoice.paymentDetails.some((d)=>d.type === PaymentDetailType.RefundRequested);
}
export function isRefundFailed(invoice) {
    return invoice.paymentDetails.some((d)=>d.type === PaymentDetailType.RefundFailed);
}
export function isVoided(invoice) {
    return invoice.displayStatusV2 === InvoiceDisplayStatusV2.Voided;
}
export function isPaidExternally(invoice) {
    return invoice.paymentDetails.some((d)=>d.type === PaymentDetailType.PaidExternally);
}
export function displayStatus(invoice) {
    return invoice.displayStatusV2;
}
export function paymentDetails(invoice) {
    return invoice.paymentDetails;
}
export function dueDate(invoice) {
    return invoice.dueDate;
}
export function formattedNumber(param) {
    let { formattedNumber } = param;
    return formattedNumber;
}
export function customerName(inv) {
    return inv.relationship.customer.name;
}
export function issuedOn(param) {
    let { issuedOn } = param;
    return issuedOn;
}
export function isPaymentMethodUnset(invoice) {
    return invoice.paymentDetails.some((d)=>d.type === PaymentDetailType.MissingPaymentMethod);
}
export function isPaymentMethodUnverified(invoice) {
    return invoice.paymentDetails.some((d)=>d.type === PaymentDetailType.PaymentMethodNotVerified);
}
export const qboIntegration = (param)=>{
    let { integration } = param;
    return integration;
};
export const xeroIntegration = (param)=>{
    let { xeroIntegration } = param;
    return xeroIntegration.getIntegration();
};
export const totalAmount = (param)=>{
    let { totalAmount } = param;
    return totalAmount;
};
export const id = (param)=>{
    let { id } = param;
    return id;
};
export const vendorName = (inv)=>inv.relationship.vendor.name;
export const otherPartyCompanyName = (inv, isVendor)=>isVendor ? customerName(inv) : vendorName(inv);
export const relationshipId = (inv)=>inv.relationship.id;
export function isSynced(inv) {
    return inv.integration.isSynced();
}
export function isNotSynced(inv) {
    return !inv.integration.isSynced();
}
export const rawTotalAmount = (param)=>{
    let { rawTotalAmount } = param;
    return rawTotalAmount;
};
export const accounting = (param)=>{
    let { accounting, invoice } = param;
    switch(accounting){
        case Accounting.QBO:
            return {
                integration: qboIntegration(invoice)
            };
        case Accounting.Xero:
            return {
                integration: xeroIntegration(invoice)
            };
    }
};
